import { IMoneySourceWidgetOption } from '../types';
import { TMoneySourcesState } from '../../../../../reducers/v2';
import { EMoneySource } from '../../../../../types/reducers/user';

export const getOptions = (availableSources: TMoneySourcesState): IMoneySourceWidgetOption[] => {
  const moneySourceTypes = availableSources.map(({ type }) => type);

  return [
    {
      disabled: moneySourceTypes.length === 1 && moneySourceTypes.includes(EMoneySource.Self),
      value: EMoneySource.Master,
      label: 'Агентство',
    },
    {
      disabled: moneySourceTypes.length === 1 && moneySourceTypes.includes(EMoneySource.Master),
      value: EMoneySource.Self,
      label: 'Личный',
    },
  ];
};
